import { render, staticRenderFns } from "./ClientServices.vue?vue&type=template&id=7f7f5b56"
import script from "./ClientServices.vue?vue&type=script&lang=ts"
export * from "./ClientServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7f5b56')) {
      api.createRecord('7f7f5b56', component.options)
    } else {
      api.reload('7f7f5b56', component.options)
    }
    module.hot.accept("./ClientServices.vue?vue&type=template&id=7f7f5b56", function () {
      api.rerender('7f7f5b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/ClientServices.vue"
export default component.exports